<template>
    <v-layout column justify-space-between class="rating-block py-4">
        <v-flex class="mb-2">
            <div class="rating-block__title">{{ title }}</div>
            <table v-if="content && content.length" class="rating-block__table">
                <tr v-for="(value, i) in content.slice(0,10)" v-if="value.item" :key="i"
                    class="rating-top"
                >
                    <td> {{ i + 1 }}. {{ value.item.name }}</td>
                    <td>{{ value.item.rating }}</td>
                    <td :class="{
                        'green-text': value.progress ? parseInt(value.progress) > 0 : false,
                        'red-text': value.progress ? String(value.progress).includes('-') : false
                    }"
                    >{{ parseInt(value.progress) > 0 ? '+' : '' }}{{ value.progress }}</td>
                </tr>
                <tr v-if="type=='internal_employee'" class="rating-top">
                    <td>...</td>
                    <td></td>
                    <td></td>
                </tr>
                <tr v-if="type=='internal_employee' && user.rating" class="red-text">
                    <td class="rating-self">
                    <img src="/images/avt-40-1.png" alt="avatar" style="max-width: 80px;max-height: 80px;"> {{ user.name }} {{ user.family }}</td>
                    <td>{{ user.rating }}</td>
                    <td>0</td>
                </tr>
            </table>
        </v-flex>
        <a class="link link--green" @click="pushPage">{{$t("Смотреть весь рейтинг")}}</a>
    </v-layout>
</template>

<script>
import {mapGetters} from 'vuex';

export default {
  props: {
    type: {
      type: String,
    },
    content: {
      type: [Array, Object],
    },
  },
  computed: {
    title() {
      switch (this.type) {
        case 'organizations':
          return this.$i18n.t('Топ-10 организаций');
        case 'org_employee':
          return this.$i18n.t('Рейтинг сотрудников') + ' ' + this.user.company_name;
        default:
          return this.$i18n.t('Общий рейтинг сотрудников');
      }
    },
    ...mapGetters('profile/user', [
      'user',
    ]),
    ...mapGetters('rating', [
      'rating',
    ]),
  },
  methods: {
    pushPage() {
      localStorage.setItem('active_tab_rating', this.type);
      this.$router.push({name: 'rating'});
    },
  },
};
</script>
